import React, { useEffect, useState } from "react";
import "../ContentSearchBar/ContentSearchBar.css";
import { ContentFilters, ContentFiltersKey, ContentSearchValues, GroupedOption, SearchValue, SingleOption } from "interfaces";
import Select, { MultiValue } from "react-select";

interface ContentSearchBarProps {
  searchValues: ContentSearchValues;
  onFilterChange: (selectedItems: ContentFilters) => void;
}


const ContentSearchBar: React.FC<ContentSearchBarProps> = ({
  searchValues,
  onFilterChange,
}) => {
  const [currentOptionList, setCurrentOptionList] = useState<GroupedOption[]>([]);

  const formatAndFilterOptionValues = (data: ContentSearchValues, filteredIDs?: ContentFilters)=> {
    const convertToSelectOptions = (
      groupLabel: string,
      items: SearchValue[]
    ) => ({
      label: groupLabel,
      options: items.map((item) => {
        if(groupLabel.toLowerCase() === "sections" && item.subject_id && filteredIDs && filteredIDs.subjects.length > 0 && !filteredIDs.subjects.includes(item.subject_id)) {
          return null;
        }
        return {
          value: `${groupLabel}-${item.id}`,
          label: item.name,
          param_type: groupLabel.toLowerCase(),
          value_id: item.id
        }
      }).filter(item => item !== null),
    }) as GroupedOption;
    return [
      convertToSelectOptions("Special", [{ id: 1, name: 'Tech Checks' }]),
      convertToSelectOptions("Templates", data.templates),
      convertToSelectOptions("Subjects", data.subjects),
      convertToSelectOptions("Sections", data.sections),
    ];
  };

  const handleChange = (value: MultiValue<GroupedOption>) => {
    const filteredIDs = (value as any as SingleOption[]).reduce((acc, item) => {
      const key = item.param_type;
      acc[key as ContentFiltersKey].push(item.value_id);
      return acc;
    }, { subjects: [], sections: [], templates: [], special: [] } as ContentFilters);

    onFilterChange(filteredIDs);
    setCurrentOptionList(formatAndFilterOptionValues(searchValues, filteredIDs));
  };

  useEffect(() => {
    if (searchValues) {
      const optionList = formatAndFilterOptionValues(searchValues);
      setCurrentOptionList(optionList);
    }
  }, [searchValues]);

  return (
    <div className="input-select-search-filed">
      <Select
        isMulti
        isClearable
        isSearchable
        name="content"
        options={currentOptionList}
        onChange={handleChange}
        className="input-select-search-filed-inner"
        placeholder="Search for content..."
      />
    </div>
  );
};

export default ContentSearchBar;
